import {
  ImageViewer,
  type CropResult,
  type ImageSource,
} from '@powerportalspro/react-fluent';
import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import { useState } from 'react';

const source: ImageSource = { kind: 'url', value: 'https://placehold.co/800x600.png' };

export function ImageViewerCroppableSample() {
  const [lastCrop, setLastCrop] = useState<CropResult | null>(null);
  const [dirty, setDirty] = useState(false);

  return (
    <>
      <ImageViewer
        source={source}
        fileName="placeholder.png"
        toolbar
        croppable
        downloadable
        onCropApplied={setLastCrop}
        onDirtyChanged={setDirty}
        style={{ width: '100%', maxWidth: '800px' }}
      />

      {lastCrop && (
        <MessageBar intent="success" layout="multiline" style={{ gridTemplateRows: 'auto', minHeight: 'auto' }}>
          <MessageBarBody>
            Cropped to {lastCrop.width} × {lastCrop.height} — file <code>{lastCrop.fileName}</code>{' '}
            ({lastCrop.bytes.length} bytes, {lastCrop.mimeType}).
          </MessageBarBody>
        </MessageBar>
      )}
      {dirty && (
        <MessageBar intent="info" layout="multiline" style={{ gridTemplateRows: 'auto', minHeight: 'auto' }}>
          <MessageBarBody>Viewer is dirty (a crop has been applied).</MessageBarBody>
        </MessageBar>
      )}
    </>
  );
}
